import React, {PropTypes} from 'react';
import QuestionRow from './QuestionRow';

const QuestionList = ({questions, user, widget, selectedTag}) => {
  if (!questions) return null;
  const questionList = questions.map((question, key) => <QuestionRow question={question} user={user} key={key} widget={widget} selectedTag={selectedTag} />);

  return (
    <div>
      {questionList}
    </div>
  );
};

QuestionList.propTypes = {
  questions: PropTypes.array.isRequired,
  user: PropTypes.object,
  selectedTag: PropTypes.string,
  widget: PropTypes.bool,
};

export default QuestionList;
